<template>
  <div>
    <div class="form_wrap">
      <img src="@/assets/img/pic_banner.png" alt v-if="isEdit" />
      <div class="nav_pos mb_nav_pos" style="border-bottom: 1px solid #dbdbdb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/">首页</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>供应商信息编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <span class="title">基本信息</span>
      <div class="change_inform">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm1" class="form_table1" :inline-message="true">
          <el-form-item class="allLine" label="供应商名称" prop="SupplierName">
            <el-input v-model="ruleForm.SupplierName" placeholder="请填写您公司的真实名称"></el-input>
            <span style="color: orange; margin-left: 10px">
              <img style="margin-left: 5px" src="@/assets/img/icon_tips0.png" />公司全称与营业执照保持一致
            </span>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="SocialCreditCode" class="allLine">
            <el-input v-model="ruleForm.SocialCreditCode" placeholder="请输入统一社会信用代码"></el-input>
            <span style="color: orange; margin-left: 10px">
              <img src="@/assets/img/icon_tips0.png" />统一社会领用代码与营业执照/事业单位法人证书的统一设备信用代码一致
            </span>
          </el-form-item>
          <el-form-item label="公司类型" prop="CompanyType" ref="CompanyType">
            <el-select v-model="ruleForm.CompanyType" placeholder="请选择" class="width_full" @change="CompanyTypeFn">
              <el-option
                v-for="item in companyTypeList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                :checked="item.selected"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="纳税人类型" prop="TaxPayerSize">
            <el-select v-model="ruleForm.TaxPayerSize" class="width_full" placeholder="请选择">
              <el-option
                v-for="item in taxPayerSizeList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                :checked="item.selected"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" 纳税人信用等级" prop="TaxPayerSize">
            <el-select v-model="ruleForm.TaxPayerLevel" class="width_full" placeholder="请选择">
              <el-option
                v-for="item in taxPayerLevelList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                :checked="item.selected"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="供应商类型" prop="SupplierType">
            <div>
              <div><el-button icon="el-icon-search" @click.stop="openSupplierTypePage">选择供应商类型</el-button></div>
              <div v-for="(item, index) in ruleForm.SupplierTypeName" :key="index">{{ item }}</div>
            </div>
          </el-form-item>
          <el-form-item label="核心产品/服务" prop="MajorProject" class="allLine">
            <el-input v-model="ruleForm.MajorProject" type="textarea" rows="1" placeholder="请填写核心产品/服务"></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" prop="LegalRepresentative">
            <el-input v-model="ruleForm.LegalRepresentative" placeholder="请填写法定代表人姓名"></el-input>
          </el-form-item>
          <el-form-item label="成立日期" prop="SetupDate">
            <el-date-picker
              class="filedate filedate1"
              value-format="yyyy-MM-dd"
              v-model="ruleForm.SetupDate"
              type="date"
              placeholder="请填写成立日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="注册资金（万元）" prop="RegisteredCapital">
            <el-input-number
              :controls="false"
              class="input_number"
              placeholder="请填写注册资金"
              :min="0"
              v-model="ruleForm.RegisteredCapital"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="实缴资金（万元）" prop="PaidInCapital">
            <el-input-number
              :controls="false"
              placeholder="实缴资金金额来自出资证明书"
              class="input_number"
              :min="0"
              v-model="ruleForm.PaidInCapital"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="注册地址" prop="RegisteredAddress" class="allLine">
            <el-cascader filterable clearable v-model="ruleForm.RegisteredAddressArr" :options="administrativeAreaList"></el-cascader>
            <el-input placeholder="请输入注册地址" v-model="ruleForm.RegisteredAddress"></el-input>
          </el-form-item>
          <el-form-item label="办公地址" prop="OfficeAddress" class="allLine">
            <el-cascader filterable clearable v-model="ruleForm.OfficeAddressArr" :options="administrativeAreaList"></el-cascader>
            <el-input placeholder="请输入办公地址" v-model="ruleForm.OfficeAddress"></el-input>
          </el-form-item>
          <el-form-item label="营业期限" prop="BusinessTermDate" class="allLine" v-if="ruleForm.IsLongBusinessDate">
            <div class="datepicker_wrap">
              <el-date-picker
                class="filedate filedate1"
                value-format="yyyy-MM-dd"
                v-model="ruleForm.BusinessTermDate[0]"
                type="date"
                placeholder="开始日期"
              ></el-date-picker>
            </div>
            <el-checkbox v-model="ruleForm.IsLongBusinessDate" class="term" @change="longterm">长期</el-checkbox>
          </el-form-item>
          <el-form-item label="营业期限" prop="BusinessTermDate" class="allLine" v-else>
            <el-date-picker
              v-model="ruleForm.BusinessTermDate"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
            ></el-date-picker>
            <el-checkbox v-model="ruleForm.IsLongBusinessDate" class="term" @change="longterm">长期</el-checkbox>
          </el-form-item>
          <el-form-item label="公司维度" prop="SupplierRelatedCompany">
            <el-select v-model="ruleForm.SupplierRelatedCompany" class="width_full" :multiple="true">
              <el-option :label="item.text" :value="item.value" v-for="(item, index) in supplierRelatedCompanyList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item label="经营范围" prop="BusinessScope" class="allLine">
            <el-input v-model="ruleForm.BusinessScope" type="textarea" rows="1" placeholder="请填写经营范围"></el-input>
          </el-form-item>
          <el-form-item label="资产总计（万元）" prop="TotalAssets">
            <el-input-number
              :controls="false"
              placeholder="请填写资产总计"
              class="input_number"
              :min="0"
              v-model="ruleForm.TotalAssets"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="上年营业收入" prop="LastYearTotalSales">
            <el-input-number
              :controls="false"
              placeholder="请填写上年营业收入"
              class="input_number"
              :min="0"
              v-model="ruleForm.LastYearTotalSales"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="售后服务承诺和措施" prop="AfterSalesService" class="allLine">
            <el-input v-model="ruleForm.AfterSalesService" type="textarea" rows="1" placeholder="请填写售后服务承诺和措施"> </el-input>
          </el-form-item>
          <el-form-item label="公司简介" prop="CompanyProfile" class="allLine">
            <el-input type="textarea" rows="1" v-model="ruleForm.CompanyProfile" placeholder="请填写公司简介"></el-input>
          </el-form-item>
          <el-form-item label="公司网址" prop="Website" class="allLine">
            <el-input type="textarea" rows="1" v-model="ruleForm.Website" placeholder="请填写公司网址"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <FileList :FileList.sync="fileList1" v-if="fileList1.length" :FileType="2" ref="MsgForm1" :supplierId="supplierId" />
      <span class="title">公司物业及人员情况</span>
      <div class="change_inform">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm2" class="form_table1">
          <el-form-item label="自有物业所有权面积(平方)" prop="OwnArea">
            <el-input v-model="ruleForm.OwnArea" placeholder="请填写自有物业所有权面积"></el-input>
          </el-form-item>
          <el-form-item label="租赁物业所有权面积(平方)" prop="LeasingArea">
            <el-input v-model="ruleForm.LeasingArea" placeholder="请填写租赁物业所有权面积"></el-input>
          </el-form-item>
          <el-form-item label="公司总人数" prop="TotalCount">
            <el-input-number
              :controls="false"
              placeholder="请填写公司总人数"
              class="input_number"
              :min="0"
              v-model="ruleForm.TotalCount"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="社保人数" prop="SocialInsuranceCount">
            <el-input-number
              :controls="false"
              placeholder="请填写社保人数"
              class="input_number"
              :min="0"
              v-model="ruleForm.SocialInsuranceCount"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="相关附件" class="allLine">
            <FileList
              :FileList.sync="fileList1"
              v-if="fileList1.length"
              :FileType="3"
              :SocialInsuranceCount="ruleForm.SocialInsuranceCount"
              ref="MsgForm3"
            />
          </el-form-item>
        </el-form>
      </div>
      <span class="title">联系人信息</span>
      <div class="change_inform">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm3" class="form_table1">
          <el-form-item label="引入来源" prop="IntroductionSource">
            <el-select v-model="ruleForm.IntroductionSource" class="width_full" placeholder="请选择">
              <el-option v-for="item in introductionSourceList" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐人" prop="Referrer" v-if="ruleForm.IntroductionSource == '0'">
            <div style="width: 100%">
              <div style="padding-bottom: 10px">
                <el-input placeholder="请输入推荐人手机" class="width_full1" v-model="ReferrerName"></el-input>
                <el-button style="margin-left: 10px" type="primary" @click="querySearchAsync()">查找</el-button>
              </div>
              已选推荐人:
              <div class="name_wrap name_wrap2" v-if="ruleForm.Referrer != 0">
                <span>{{ ruleForm.ReferrerName }}|{{ ruleForm.ReferrerMobile }}</span>
                <i style="cursor: pointer" @click="deleteReferrerName()" class="el-icon-delete"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="引入项目" prop="ProjectName" v-else-if="ruleForm.IntroductionSource == '1'">
            <div style="width: 100%">
              <div style="padding-bottom: 10px">
                <el-input placeholder="请输入完整的项目名称" class="width_full1" v-model="ProjectName"></el-input>
                <el-button style="margin-left: 10px" type="primary" @click="querySearchAsync1()">查找</el-button>
              </div>
              已选项目:
              <div class="name_wrap name_wrap2" v-if="ruleForm.SchemeId != 0">
                <span>{{ ruleForm.ProjectName }}</span>
                <i style="cursor: pointer" @click="deleteProjectName()" class="el-icon-delete"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="联系人信息" class="allLine">
            <div class="MsgForm" style="width: -webkit-fill-available">
              <div class="form_wrap" style="height: 30px">
                <div class="btn_wrap" style="width: unset; margin: unset">
                  <img src="@/assets/img/btn_add.png" alt @click="addContact" />
                  <img src="@/assets/img/btn_delete.png" alt @click="removeContact" />
                </div>
              </div>
              <table class="enclosure">
                <tbody>
                  <tr>
                    <th width="40px">
                      <el-checkbox v-model="allContactCheck"></el-checkbox>
                    </th>
                    <th><span class="icon_must">*</span>主要联系人</th>
                    <th><span class="icon_must">*</span>姓名</th>
                    <th><span class="icon_must">*</span>职位</th>
                    <th><span class="icon_must">*</span>手机号码</th>
                    <th><span class="icon_must">*</span>电子邮箱</th>
                  </tr>
                  <tr v-for="(item, index) in spplierContactList" :key="index">
                    <td><el-checkbox v-model="item.check"></el-checkbox></td>

                    <td>
                      <el-select v-model="item.IsPrimary" @change="setIsPrimary(index)">
                        <el-option label="主要联系人" :value="true"></el-option>
                        <el-option label="非主要联系人" :value="false"></el-option>
                      </el-select>
                    </td>
                    <td><el-input style="width: 150px" v-model="item.ContactName"></el-input></td>
                    <td><el-input style="width: 150px" v-model="item.Duty"></el-input></td>
                    <td><el-input style="width: 150px" v-model="item.Mobile"></el-input></td>
                    <td><el-input style="width: 150px" v-model="item.Email"></el-input></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <span class="title">银行收款信息</span>
      <div class="change_inform">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm4" class="form_table1">
          <el-form-item label="开户名称" prop="Bank">
            <el-input v-model="ruleForm.Bank" placeholder="请填写开户银行名称"></el-input>
          </el-form-item>

          <el-form-item label="开户银行账户" prop="BankAccount">
            <el-input v-model="ruleForm.BankAccount" placeholder="请填写开户银行账户"></el-input>
          </el-form-item>
          <el-form-item label="联行号" prop="BankApprovalNumber">
            <el-input v-model="ruleForm.BankApprovalNumber" maxlength="12" placeholder="请填写联行号"></el-input>
          </el-form-item>
          <el-form-item label="开户银行名称" prop="BankAccountName">
            <el-input v-model="ruleForm.BankAccountName" placeholder="请填写开户名称"></el-input>
          </el-form-item>
          <el-form-item label="相关附件" class="allLine">
            <FileList :FileList.sync="fileList1" v-if="fileList1.length" :FileType="4" ref="MsgForm4" />
          </el-form-item>
        </el-form>
      </div>
      <Qualification
        :FileList.sync="supplierQualificationList"
        v-if="supplierQualificationList.length && ruleForm.TaxPayerSize != 3 && ruleForm.TaxPayerSize != 4"
        ref="QualificationForm"
      />
    </div>
    <SupplierType
      :tableData="supplierTypeTree"
      :tableData1="supplierTypeList"
      :dialogvisible.sync="dialogvisible"
      :selectSupplierType.sync="selectSupplierType"
    ></SupplierType>
    <div class="btn_wrap" v-if="isEdit">
      <span class="btn_1" @click="submit(false)">保存草稿</span>
      <span class="btn_1" @click="submit(true)">提交申请</span>
    </div>
  </div>
</template>

<script>
import SupplierType from './SupplierType.vue'
import FileList from '@/components/common/FileList'
import Qualification from '@/components/common/Qualification'
// import ProductInfo from '@/components/common/ProductInfo'
// import IntellectualPropertyFrom from '@/components/common/IntellectualPropertyFrom'
import { validateEmail, validatemobile1, validateIdCar2, validateSocialCreditCode, validContact } from '@/assets/js/util'
export default {
  components: {
    FileList,
    // ProductInfo,
    // IntellectualPropertyFrom,
    SupplierType,
    Qualification
  },
  props: {
    parentForm: Object
  },
  data() {
    var validRegisteredAddress = (rule, value, callback) => {
      if (this.ruleForm.RegisteredAddressArr[0] == null || this.ruleForm.RegisteredAddress == '') {
        callback(new Error('请填写注册地址'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    var validOfficeAddress = (rule, value, callback) => {
      if (this.ruleForm.OfficeAddressArr[0] == null || this.ruleForm.OfficeAddress == '') {
        callback(new Error('请填写办公地址'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    return {
      value: '',
      treeprops: {
        label: 'name',
        Child: 'children'
      },
      ReferrerName: '',
      ProjectName: '',
      selectSupplierType: [],
      dialogvisible: false,
      isEdit: false,
      allQualificationCheck: '',
      allEnclosureCheck: '',
      allContactCheck: '',
      ruleForm: {},
      FileList1: [],
      rules: {
        SupplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        SocialCreditCode: [{ required: true, message: '', trigger: 'blur' }],
        SupplierType: [{ required: true, message: '请选择供应商类型', trigger: 'blur' }],
        LegalRepresentative: [{ required: true, message: '请输入法定代表人', trigger: 'blur' }],
        RegisteredCapital: [{ required: true, message: '请输入注册资本', trigger: 'blur' }],
        CompanyReputation: [{ required: true, message: '请输入企业信誉', trigger: 'blur' }],
        PaidInCapital: [{ required: true, message: '请输入实缴资本', trigger: 'blur' }],
        AfterSalesService: [{ required: true, message: '请输入售后服务承诺和措施', trigger: 'blur' }],
        ReferrerName: [{ required: this.ReferrerNameVaildate, message: '请输入推荐人', trigger: 'blur' }],
        ProjectName: [{ required: this.ProjectNameVaildate, message: '请输入引入项目', trigger: 'blur' }],
        SupplierType: [{ required: true, message: '请选择供应商类型', trigger: 'blur' }],
        SupplierNature: [{ required: true, message: '请选择供应商性质', trigger: 'blur' }],
        SupplierProductList: [{ required: true, validator: this.SupplierProductVaildate, message: '请选择供核心产品', trigger: 'blur' }],
        // SupplierProductBrandList: [{ required: true, message: '请选择供核心产品品牌', trigger: 'blur' }],
        StaffSize: [{ required: true, message: '请选择人员规模', trigger: 'blur' }],
        BusinessTermDate: [{ required: true, message: '请输入营业期限', trigger: 'blur' }],
        BusinessScope: [{ required: true, message: '请输入经营范围', trigger: 'blur' }],
        RegisteredAddress: [{ required: true, message: '请输入注册地址', trigger: 'blur', validator: validRegisteredAddress }],
        OfficeAddress: [{ required: true, message: '请输入办公地址', trigger: 'blur', validator: validOfficeAddress }],
        // CompanyProfile: [{ required: true, message: '请输入公司简介', trigger: 'blur' }],
        Contact: [{ required: true, validator: validContact, trigger: 'blur' }],
        CertificateType: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        CertificateNo: [{ required: true, message: '请输入正确的证件号', trigger: 'blur' }],
        Bank: [{ required: true, message: '请输入开户银行名称', trigger: 'blur' }],
        BankAccount: [{ required: true, message: '请输入开户银行账户', trigger: 'blur' }],
        BankApprovalNumber: [{ required: true, message: '请输入联行号', trigger: 'blur' }],
        CompanyType: [{ required: true, message: '请选择公司类型', trigger: 'blur' }],
        IntroductionSource: [{ required: true, message: '请选择引入来源', trigger: 'blur' }],
        RegistrationAuthority: [{ required: true, message: '请填写登记机关', trigger: 'blur' }],
        ContactAddress: [{ required: true, message: '请填写联系地址', trigger: 'blur' }],
        ProductSource: [{ required: true, message: '请选择产品来源', trigger: 'blur' }],
        TaxPayerSize: [{ required: true, message: '请选择纳税人规模', trigger: 'blur' }],
        TaxPayerLevel: [{ required: true, message: '请选择纳税人信用等级', trigger: 'blur' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        Mobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        // QualityDirector: [{ required: true, message: '请填写质管负责人', trigger: 'blur' }],
        // QualityMobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        FixedAssets: [{ required: false, message: '请输入固定资产', trigger: 'blur' }],
        WorkerNumber: [{ required: false, message: '请输入生产工人数', trigger: 'blur' }],
        QualityManagerNumber: [{ required: false, message: '请输入质量管理人数', trigger: 'blur' }],
        TechnicianNumber: [{ required: false, message: '请输入技术人员数', trigger: 'blur' }],
        ProductTestingMethod: [{ required: false, message: '请输入产品检测手段', trigger: 'blur' }],
        SupplierRelatedCompany: [{ required: true, message: '请选择公司维度', trigger: 'blur' }],
        LastYearTotalSales: [{ required: true, message: '请输入去年销售总额', trigger: 'blur' }],
        MajorProject: [{ required: true, message: '请填写主要产品或服务', trigger: 'blur' }],
        BankAccountName: [{ required: true, message: '请填写开户名称', trigger: 'blur' }],
        SetupDate: [{ required: true, message: '请填写成立日期', trigger: 'blur' }],
        TotalAssets: [{ required: true, message: '请填写资产总计', trigger: 'blur' }],
        TotalCount: [{ required: true, message: '请填写公司总人数', trigger: 'blur' }],
        SocialInsuranceCount: [{ required: true, message: '请填写社保人数', trigger: 'blur' }]
      },
      isSupplierOtherType: false,
      socialCreditCode: '',
      baseDataSupplierQualificationList: [],
      supplierQualificationList: [],
      spplierContactList: [],
      supplierTypeTree: [],
      supplierNatureList: [],
      introductionSourceList: [],
      taxPayerSizeList: [],
      propertyStateList: [],
      supplierTypeList: [],
      supplierCategoryList: [],
      registeredCurrencyList: [],
      staffSizeList: [],
      companyList: [],
      supplierRelatedCompanyList: [],
      fileList1: [],
      fileList2: [],
      administrativeAreaList: [],
      companyTypeList: [],
      taxPayerLevelList: [],
      supplierId: '',
      userList: [],
      schemeList: []
    }
  },
  computed: {
    CertificateType() {
      return this.ruleForm.CertificateType
    },
    SocialCreditCode() {
      return this.ruleForm.SocialCreditCode
    },
    // RegisteredCapital() {
    //   return this.ruleForm.RegisteredCapital
    // },
    // FixedAssets() {
    //   return this.ruleForm.FixedAssets
    // },
    // LastYearTotalSales() {
    //   return this.ruleForm.LastYearTotalSales
    // },
    // ReferrerName() {
    //   return this.ruleForm.ReferrerName
    // },
    ReferrerNameVaildate() {
      return this.ruleForm.IntroductionSource == '0' ? true : false
    },
    ProjectNameVaildate() {
      return this.ruleForm.IntroductionSource == '1' ? true : false
    }
    // PostalCode() {
    //   return this.ruleForm.PostalCode;
    // }
  },
  watch: {
    // ReferrerName(newVal) {
    //   const reg = /^1[3-9]{1}[0-9]{9}$/
    //   if (reg.test(newVal)) {
    //     this.ruleForm.Referrer = 0
    //   }
    // },
    CertificateType(newVal, oldVal) {
      // if(newVal!==oldVal){
      //   this.ruleForm.CertificateNo="";
      // }
      if (newVal == 1) {
        //身份证验证
        this.rules.CertificateNo[0].validator = validateIdCar2
      } else {
        delete this.rules.CertificateNo[0].validator
      }
    },
    // SocialCreditCode(newVal, oldVal) {
    //   if (this.isEdit) {
    //     if (newVal == this.socialCreditCode) {
    //       delete this.rules.SocialCreditCode[0].validator;
    //     } else {
    //       this.rules.SocialCreditCode[0].validator = validateSocialCreditCode;
    //     }
    //   }
    // },
    RegisteredCapital(newVal, oldVal) {
      this.ruleForm.RegisteredCapital = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    FixedAssets(newVal, oldVal) {
      this.ruleForm.FixedAssets = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    LastYearTotalSales(newVal, oldVal) {
      this.ruleForm.LastYearTotalSales = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    PostalCode(newVal, oldVal) {
      if (newVal.length > 6) {
        this.ruleForm.PostalCode = newVal.substr(0, 6)
      }
    },
    allContactCheck(val) {
      this.spplierContactList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    selectSupplierType(newVal, oldVal) {
      var isVaildate = false
      this.supplierQualificationList = []
      this.ruleForm.SupplierTypeName = []
      this.ruleForm.SupplierType = []
      newVal.forEach((item) => {
        this.ruleForm.SupplierTypeName.push(item.firstName + '-' + item.secondName + '-' + item.supplierTypeName)
        this.ruleForm.SupplierType.push(item.paramItemCode)
        var list = this.baseDataSupplierQualificationList.filter((m) => m.SupplierType.includes(item.paramItemCode))
        console.log(list)
        list.forEach((item1, index) => {
          var data = {
            QualificationTypeId: item1.QualificationTypeId,
            check: false,
            QualificationTypeName: item1.QualificationName,
            FileId: 0,
            QualificationName: '',
            IsMust: item1.IsMust,
            QualificationId: 0,
            Remark: '',
            ServiceLifeDate: ['', ''],
            QualificationStatus: ''
          }
          if (this.supplierQualificationList.filter((m) => m.QualificationTypeId == item1.QualificationTypeId).length == 0) {
            this.supplierQualificationList.push(data)
          }
        })

        // if (item.paramItemCode.indexOf('GC') >= 0 || item.paramItemCode.indexOf('SP') >= 0) {
        //   isVaildate = true
        // }
      })

      // if ((isVaildate = true)) {
      //   this.rules.FixedAssets[0].required = true
      //   this.rules.WorkerNumber[0].required = true
      //   this.rules.QualityManagerNumber[0].required = true
      //   this.rules.TechnicianNumber[0].required = true
      //   this.rules.ProductTestingMethod[0].required = true
      //   this.rules.SupplierProductList[0].required = true
      // } else {
      //   this.rules.FixedAssets[0].required = false
      //   this.rules.WorkerNumber[0].required = false
      //   this.rules.QualityManagerNumber[0].required = false
      //   this.rules.TechnicianNumber[0].required = false
      //   this.rules.ProductTestingMethod[0].required = false
      //   this.rules.SupplierProductList[0].required = false
      // }
    },
    ReferrerNameVaildate(newVal) {
      this.rules.ReferrerName[0].required = newVal
    }
  },

  mounted() {
    this.getList()
    // if (!this.isEdit) {
    //   this.rules.SocialCreditCode[0].validator = validateSocialCreditCode;
    // }
  },
  methods: {
    SupplierProductVaildate(rule, value, callback) {
      if (this.ruleForm.SupplierProductList.length == 0 && this.ruleForm.OtherSupplierProductList === '') {
        callback(new Error('请填写核心产品'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    },
    getList() {
      let loginName

      if (this.$route.query.loginName) {
        loginName = this.$route.query.loginName
        this.isEdit = true
      } else {
        loginName = this.parentForm.enloginName
      }
      this.postRequest('SupplierLogin/BaseDataEdit', {
        loginName: loginName
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.ruleForm = res.data.supplierData
          this.supplierId = this.ruleForm.SupplierId
          this.baseDataSupplierQualificationList = res.data.baseDataSupplierQualificationList
          this.supplierQualificationList = res.data.supplierQualificationList
          this.spplierContactList = res.data.spplierContactList
          this.supplierTypeTree = res.data.supplierTypeTree
          this.supplierNatureList = res.data.supplierNatureList
          this.introductionSourceList = res.data.introductionSourceList
          this.taxPayerSizeList = res.data.taxPayerSizeList
          this.propertyStateList = res.data.propertyStateList
          this.supplierTypeList = res.data.supplierTypeList
          this.supplierCategoryList = res.data.supplierCategoryList
          this.registeredCurrencyList = res.data.registeredCurrencyList
          this.staffSizeList = res.data.staffSizeList
          // this.userList = res.data.userList
          // this.schemeList = res.data.schemeList
          this.companyList = res.data.companyList
          this.supplierRelatedCompanyList = res.data.supplierRelatedCompanyList

          this.fileList1 = res.data.fileList1
          // this.fileList2 = res.data.fileList2
          this.administrativeAreaList = res.data.administrativeAreaList

          this.companyTypeList = res.data.companyTypeList
          this.taxPayerLevelList = res.data.taxPayerLevelList

          this.handleChange()
          if (this.ruleForm.RegisteredCapital == 0) {
            this.ruleForm.RegisteredCapital = ''
          }
          this.socialCreditCode = this.ruleForm.SocialCreditCode
          // this.rules.BusinessTermEndDate[0].required = !this.ruleForm
          //   .IsLongBusinessDate;
          if (this.ruleForm.SupplierId == 0) {
            this.ruleForm.BusinessTermDate = ['', '']
            this.ruleForm.SupplierNature = ''
          }
          if (this.supplierQualificationList.length == 0 && this.ruleForm.SupplierType.length > 0) {
            this.ruleForm.SupplierType.forEach((item) => {
              var list = this.baseDataSupplierQualificationList.filter((m) => m.SupplierType.includes(item))
              list.forEach((item1, index) => {
                var data = {
                  QualificationTypeId: item1.QualificationTypeId,
                  check: false,
                  QualificationTypeName: item1.QualificationName,
                  FileId: 0,
                  QualificationName: '',
                  IsMust: item1.IsMust,
                  QualificationId: 0,
                  Remark: '',
                  ServiceLifeDate: ['', ''],
                  QualificationStatus: ''
                }
                if (this.supplierQualificationList.filter((m) => m.QualificationTypeId == item1.QualificationTypeId).length == 0) {
                  this.supplierQualificationList.push(data)
                }
              })
            })
          }
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    longterm(val) {
      if (val) {
        if (!this.ruleForm.BusinessTermDate) {
          this.ruleForm.BusinessTermDate = ['', '']
        }
      } else {
        this.ruleForm.BusinessTermDate = []
      }
    },
    handleChange(val) {
      if (val) {
        this.$refs['SupplierType'].clearValidate()
      }
      //供应商
      if (this.ruleForm.SupplierType.includes(0)) {
        this.isSupplierOtherType = true
      } else {
        this.isSupplierOtherType = false
      }
    },
    focusError() {
      setTimeout(() => {
        if (document.getElementsByClassName('el-form-item__error').length > 0) {
          // console.log(
          //   document.getElementsByClassName("el-form-item__error")[0]
          // );
          this.$message.error(document.getElementsByClassName('el-form-item__error')[0].innerText)
        }
      }, 500)
    },
    validateSupplierType() {
      const EmailReg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/ //邮箱验证
      const mobileReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/ //手机号验证
      var issumit = true
      if (this.ruleForm.BusinessTermDate[0] == '' && issumit == true) {
        this.$message.error('请选择营业期限')
        issumit = false
        return false
      }
      if (this.ruleForm.SupplierType.length == 0 && issumit == true) {
        this.$message.error('请选择供应商类型')
        issumit = false
        return false
      }
      if (this.ruleForm.Referrer == 0 && this.ruleForm.IntroductionSource == '0' && issumit == true) {
        this.$message.error('请填写推荐人')
        issumit = false
        return false
      }
      if (this.ruleForm.SchemeId == 0 && this.ruleForm.IntroductionSource == '1' && issumit == true) {
        this.$message.error('请填写引入项目')
        issumit = false
        return false
      }

      if (this.spplierContactList.length < 2 && issumit == true) {
        this.$message.error('联系人信息请至少填写两个')
        issumit = false
        return false
      }
      if (this.spplierContactList.filter((item) => item.IsPrimary).length == 0 && issumit == true) {
        this.$message.error('请设置一个联系人为主要联系人')
        issumit = false
        return false
      }
      this.spplierContactList.forEach((item, index) => {
        if ((item.ContactName == '' || item.ContactName == null) && issumit == true) {
          this.$message.error('请填写第' + (Number(index) + 1) + '行联系人的联系人名称')
          issumit = false
          return false
        }
        if ((item.Duty == '' || item.Duty == null) && issumit == true) {
          this.$message.error('请填写' + (Number(index) + 1) + '行联系人的职位')
          issumit = false
          return false
        }

        if ((item.Mobile == '' || item.Mobile == null) && issumit == true) {
          this.$message.error('请填写' + (Number(index) + 1) + '行联系人的手机号码')
          issumit = false
          return false
        }
        if (
          this.spplierContactList.filter((item1) => {
            return item1.Mobile == item.Mobile
          }).length > 1 &&
          issumit == true
        ) {
          this.$message.error('填写的联系人的手机号码重复了，请确认')
          issumit = false
          return false
        }
        if (!mobileReg.test(item.Mobile) && issumit == true) {
          this.$message.error('请正确填写' + (Number(index) + 1) + '行联系人的手机号码')
          issumit = false
          return false
        }
        if ((item.Email == '' || item.Email == null) && issumit == true) {
          this.$message.error('请填写' + (Number(index) + 1) + '行联系人的电子邮箱')
          issumit = false
          return false
        }
        if (!EmailReg.test(item.Email) && issumit == true) {
          this.$message.error('请正确填写' + (Number(index) + 1) + '行联系人的电子邮箱')
          issumit = false
          return false
        }
        if (
          this.spplierContactList.filter((item1) => {
            return item1.Email == item.Email
          }).length > 1 &&
          issumit == true
        ) {
          this.$message.error('填写的联系人的电子邮箱重复了，请确认')
          issumit = false
          return false
        }
      })
      // let arr = this.$refs.treerefs.getCheckedKeys();
      // let arr1 = this.$refs.treerefs.getCheckedNodes();
      // if (arr.length == 0) {
      //   this.$message.error("请选择供应商类型");
      //   return false;
      // }
      // arr1.forEach(item => {
      //   if (item.other && issumit) {
      //     if (!document.getElementById(item.id).value) {
      //       this.$message.error("请输入其他供应商类型");
      //       issumit = false;
      //     } else {
      //       item.othervalue = document.getElementById(item.id).value;
      //     }
      //   }
      // });
      // this.ruleForm.SupplierType = JSON.stringify(arr1);
      return issumit
    },

    formRule() {
      return new Promise((resolve, reject) => {
        var flag = this.validateSupplierType()
        // console.log(flag);
        if (flag) {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.$refs.ruleForm2.validate((valid1) => {
                if (valid1) {
                  this.$refs.ruleForm3.validate((valid2) => {
                    if (valid2) {
                      this.$refs.ruleForm4.validate((valid3) => {
                        resolve(true)
                        if (valid3) {
                          resolve(true)
                        } else {
                          this.focusError()
                          resolve(false)
                        }
                      })
                    } else {
                      this.focusError()
                      resolve(false)
                    }
                  })
                } else {
                  this.focusError()
                  resolve(false)
                }
              })
            } else {
              this.focusError()
              resolve(false)
            }
          })
        } else {
          resolve(false)
        }

        //
      })
    },
    deduplicateObjects() {
      const seen = new Set()
      // 必须将结果重新赋值给 this.userList，才能触发视图更新
      this.spplierContactList = this.spplierContactList.filter((item) => {
        // 如果 seen 中已存在该 id，则过滤掉；否则加入 seen 并保留
        return !seen.has(item.ContactName) && seen.add(item.ContactName)
      })
    },
    async submit(submit) {
      this.deduplicateObjects()
      // console.log(this.ruleForm.SupplierProductList.length == 0 && this.ruleForm.OtherSupplierProductList === '')
      if (submit) {
        let isSubmit = await this.formRule()
        this.$refs.MsgForm1.ruleList()
        this.$refs.MsgForm3.ruleList()
        this.$refs.MsgForm4.ruleList()
        if (this.ruleForm.TaxPayerSize != 3 && this.ruleForm.TaxPayerSize != 4) {
          this.$refs.QualificationForm.ruleList()
        }

        console.log('sss', isSubmit)
        if (
          this.$refs.MsgForm1.iserror &&
          this.$refs.MsgForm3.iserror &&
          this.$refs.MsgForm4.iserror &&
          (this.ruleForm.TaxPayerSize != 3 && this.ruleForm.TaxPayerSize != 4 ? this.$refs.QualificationForm.iserror : true) &&
          isSubmit
        ) {
          this.save(submit)
        }
      } else {
        this.$refs.MsgForm1.ruleList1()
        this.$refs.MsgForm3.ruleList1()
        this.$refs.MsgForm4.ruleList1()
        if (this.ruleForm.TaxPayerSize != 3 && this.ruleForm.TaxPayerSize != 4) {
          this.$refs.QualificationForm.ruleList1()
        }

        this.save(submit)
      }
    },

    save(isSubmit) {
      var fileList = []
      var fileList1 = []
      if (this.ruleForm.TaxPayerSize != 3 && this.ruleForm.TaxPayerSize != 4) {
        fileList1 = this.$refs.QualificationForm.list
      }
      // console.log(this.$refs.MsgForm1.list)
      // console.log(this.$refs.MsgForm3.list)
      // console.log(this.$refs.MsgForm4.list)

      fileList.push(...this.$refs.MsgForm1.list)
      // fileList.push(...this.$refs.MsgForm3.list)
      // fileList.push(...this.$refs.MsgForm4.list)
      this.postRequest('SupplierLogin/BaseDataSave', {
        fileListJson: JSON.stringify(fileList),
        qualificationListJson: JSON.stringify(fileList1),
        baseDataJson: JSON.stringify(this.ruleForm),
        contactDataListJson: JSON.stringify(this.spplierContactList),
        isSubmit: isSubmit
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.supplierId = res.data.supplierId
            if (isSubmit) {
              this.$router.push({
                //传外键值到审核进度详细页面
                path: '/SuccessApply',
                query: { name: '注册流程信息' }
              })
            } else {
              this.$router.push({
                //传外键值到审核进度详细页面
                path: '/RegisterForm',
                query: { loginName: res.data.loginName }
              })
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    scaleNum(val) {
      if (val) {
        this.$refs['scalenum'].clearValidate()
      }
    },
    RegisteredCurrencyFn(val) {
      if (val) {
        this.$refs['RegisteredCurrency'].clearValidate()
      }
    },
    CertificateTypeFn(val) {
      if (val) {
        this.$refs['CertificateType'].clearValidate()
      }
    },
    CompanyTypeFn(val) {
      if (val) {
        this.$refs['CompanyType'].clearValidate()
      }
    },
    // IntroductionSourceFn(val) {
    //   if (this.ruleForm.IntroductionSource == 1) {
    //     if (this.ruleForm.SocialCreditCode == '' || this.ruleForm.SocialCreditCode == null) {
    //       this.ruleForm.IntroductionSource = '0'
    //       this.$message.error('请先输入社会信用代码后选择引入来源')
    //     }
    //     this.postRequest('SupplierLogin/ValidateIntroductionSource', {
    //       socialCreditCode: this.ruleForm.SocialCreditCode
    //     }).then((res) => {
    //       if (res.data.errcode == 0) {
    //         this.rules.ReferrerName[0].required = false
    //       } else {
    //         this.$message.error(res.data.errmsg)
    //         this.ruleForm.IntroductionSource = '0'
    //       }
    //     })
    //   } else {
    //     this.rules.ReferrerName[0].required = true
    //   }
    // },
    // renderContent(h, { node, data, store }) {
    //   if (data.other) {
    //     return (
    //       <span class="custom-tree-node">
    //         <span> {node.label} </span>{" "}
    //         <input
    //           id={data.id}
    //           value={data.othervalue}
    //           style="height:26px;line-height:26px;margin-left:5px"
    //           class="el-input__inner otherinput"
    //         />{" "}
    //       </span>
    //     );
    //   } else {
    //     return (
    //       <span class="custom-tree-node">
    //         <span> {node.label} </span>{" "}
    //       </span>
    //     );
    //   }
    // },
    querySearchAsync() {
      this.userList = []
      this.postRequest('Common/GetUserByMobile', {
        mobile: this.ReferrerName
      }).then((res) => {
        if (res.data.errcode == 0) {
          console.log(res.data.userList)
          this.userList = res.data.userList
          const reg = /^1[3-9]{1}[0-9]{9}$/
          var results = this.ReferrerName
            ? this.userList.filter((item) => {
                return item.Mobile1 == this.ReferrerName
              })
            : []
          if (!reg.test(this.ReferrerName)) {
            this.$message.error('请输入正确的推荐人手机号！')
            this.ruleForm.Referrer = 0
          }
          if (reg.test(this.ReferrerName) && results.length == 0) {
            this.$message.error('供应商入库推荐人的手机号码默认为我司员工在我司系统报备号码，现查无此人，请联系我司对接人员！')
            this.ruleForm.Referrer = 0
          }
          if (results.length > 0) {
            this.ruleForm.Referrer = results[0].UserId
            this.ruleForm.ReferrerName = results[0].UserName
            this.ruleForm.ReferrerMobile = results[0].Mobile1
          }
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    querySearchAsync1() {
      this.schemeList = []
      this.postRequest('Common/GetSchemeByProjectName', {
        projectName: this.ProjectName
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.schemeList = res.data.schemeList
          if (this.schemeList.length == 0) {
            this.$message.error('未找到项目，请确认！')
            this.ruleForm.SchemeId = 0
          }
          if (this.schemeList.length > 0) {
            this.ruleForm.SchemeId = this.schemeList[0].SchemeId
            this.ruleForm.ProjectName = this.schemeList[0].ProjectName
          }
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    deleteReferrerName() {
      this.ruleForm.Referrer = 0
      this.ruleForm.ReferrerName = ''
      this.ruleForm.ReferrerMobile = ''
    },
    deleteProjectName() {
      this.ruleForm.SchemeId = 0
      this.ruleForm.ProjectName = ''
    },
    // createFilter(queryString) {
    //   return user => {
    //     return (
    //       String(user.Mobile1)===queryString
    //     );
    //   };
    // },
    openSupplierTypePage() {
      this.dialogvisible = true
    },
    addContact() {
      var data = {
        ContactName: '',
        Duty: '',
        Mobile: '',
        Email: '',
        IsPrimary: false,
        check: false
      }
      this.spplierContactList.push(data)
    },
    removeContact() {
      this.spplierContactList = this.spplierContactList.filter((item) => {
        return !item.check
      })
    },
    setIsPrimary(index1) {
      if (this.spplierContactList[index1].IsPrimary == true) {
        for (let index = 0; index < this.spplierContactList.length; index++) {
          if (index != index1) {
            this.spplierContactList[index].IsPrimary = false
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.userName {
  text-overflow: ellipsis;
  overflow: hidden;
}
.mobile {
  font-size: 12px;
  color: #b4b4b4;
}
.form_wrap .is-active {
  border-color: #fff !important;
  background: #fff !important;
}

.supplierType {
  .el-checkbox-group {
    label {
      display: inline-block;
      width: 108px;
    }
  }

  ::v-deep .el-form-item__content {
    .el-form-item__error {
      top: 98% !important;
    }
  }
}

.supplierOtherType {
  display: inline-block;
  margin: 0 0 0 -45px;

  ::v-deep .el-form-item__content {
    .el-form-item__error {
      top: 105% !important;
    }
  }
}

.btn_wrap {
  width: 500px;
  margin: 30px auto 50px;

  .btn_1 {
    font-weight: bold;
    margin: 0 30px;
  }

  .btn {
    color: #fff;
    background: #2db7f5;
  }
}

.businessTermDate {
  .el-input {
    width: 364px !important;
  }

  .businessTermEndDate {
    margin-bottom: 0 !important;
    margin-left: 10px;

    .el-input {
      width: 100% !important;
    }

    ::v-deep.el-form-item__label:before {
      display: none;
    }
  }
}

.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 100% !important;
    text-align: center;

    .el-range-input {
      font-size: 14px;
    }
  }
}

// .tree ::v-deep .el-tree-node {
//   .el-tree-node__children {
//     white-space: normal;
//     .el-tree-node {
//       display: inline-block;
//     }
//   }
// }
.tree {
  width: 400px;
  background: transparent !important;
}

.width_full {
  width: 100% !important;
}
.width_full1 {
  width: 70% !important;
}
.input_number ::v-deep .el-input-number__decrease {
  display: none;
}

.input_number ::v-deep .el-input-number__increase {
  display: none;
}

.input_number ::v-deep .el-input__inner {
  // padding-left: 10px !important;
  // padding-right: 10px !important;
}
.addressCascader {
  width: 180px;
}
.cascader {
  ::v-deep .el-input-group__prepend {
    padding: unset;
    border: unset;
    border-radius: unset;
  }
  ::v-deep .el-form .el-form-item .el-input {
    width: unset;
  }
}
.name_wrap {
  border: 1px solid #606266;
  margin-left: 11px;
  border-radius: 10px;
  padding: 0 4px;
}

.name_wrap2 {
  display: inline-block;
  padding: 5px;
}
</style>